import { useMutation } from 'react-query';
import { request } from '../utils/axios-utils';

const fetchPendencyTrend = ({ companyCode, fromDate, toDate }) => {
    return request({
        url: '/tracker/pendency-trend',
        method: 'GET',
        params: { companyCode, fromDate, toDate },
    });
};

export const usePendencyTrend = () => {
    return useMutation(fetchPendencyTrend);
};
